import React from "react";
import {Card, Container, Form, Input, Message} from "semantic-ui-react";
import Select from "react-select";
import lodash from "lodash/core";
import {connect} from "react-redux";
import { JsonViewer } from '@textea/json-viewer'
import * as Validation from "../../common/utils/Validation";
import {
    setDateOfBirthTestcache,
    setTestcacheCountry,
    setTestcacheFormValues,
    setTestcacheSourceType
} from "../actions/TestcacheActions";
import DatePicker from "../../common/components/DatePicker";


const countryOptions = require("../../common/resources/countries.json");

export class AddEditTestcacheForm extends React.Component {

    // create a ref for automatic smooth scrolling to the end of
    // the form in case of error/warning
    messagesEndRef = React.createRef();

    componentDidUpdate(prevProps, prevState, snapshot) {
        // eslint-disable-next-line no-unused-expressions
        (this.props.formErrorNotification || this.props.formWarningNotification)
            ? this.scrollToBottom() : null
    }

    scrollToBottom = () => {
        this.messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    handleInputChange = (e, { name, value }) => {
        this.props.setTestcacheForm({ name, value });
    };

    handleDateOfBirth = day => {
        this.props.setDateOfBirth({ day });
    };

    handleTestcacheCountryChange = country => {
        this.props.setTestcacheRecordCountry({ country });
    };

    handleSourceTypeChange = data_source_type => {
            this.props.setTestcacheSourceType({ data_source_type });
    };

    handleTestcacheDismiss = () => {
        Validation.clearMessages();
    }

    render() {
        const {
            testcacheObject,
            postmanObject,
            sourceTypeOptions,
            formMessage, formMessageHeader, formWarningNotification, formErrorNotification,
        } = this.props;

        return(
            <div className="form-page-container">
                <Container>
                    <Form>
                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">Name:</h4>

                                <Form.Group widths="equal">

                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Complete Name"
                                        placeholder="Complete Name"
                                        value={testcacheObject.completename}
                                        name="completename"
                                    />

                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Given Full Name"
                                        placeholder="Given Full Name"
                                        value={testcacheObject.givenfullname}
                                        name="givenfullname"
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Surname First"
                                        placeholder="Surname First"
                                        value={testcacheObject.surname_first}
                                        name="surname_first"
                                    />
                                </Form.Group>

                                <Form.Group widths="equal">

                                    <Form.Field required>
                                        <label>Source Type</label>
                                        <Select
                                            onChange={this.handleSourceTypeChange}
                                            options={sourceTypeOptions}
                                            placeholder="Source Type"
                                            isClearable={true}
                                            name="data_source_type"
                                            getOptionLabel={option => option.label}
                                            getOptionValue={option => option.value}
                                            value={lodash.find(sourceTypeOptions, {
                                                label: testcacheObject.data_source_type
                                            })}
                                        />
                                    </Form.Field>

                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="National ID"
                                        placeholder="National ID"
                                        value={testcacheObject.nationalid}
                                        name="nationalid"
                                    />

                                    <Form.Field>
                                        <label>Date of Birth</label>
                                        <DatePicker onChange={this.handleDateOfBirth}
                                            value={testcacheObject?.dob ? testcacheObject.dob : null}
                                        />
                                    </Form.Field>

                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Phone Number"
                                        placeholder="Phone Number"
                                        value={testcacheObject.phone}
                                        name="phone"
                                    />

                                </Form.Group>

                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Address Lines:
                                </h4>

                                <Form.Field
                                    onChange={this.handleInputChange}
                                    control={Input}
                                    type="text"
                                    label="Address Line 1"
                                    placeholder="Address Line 1"
                                    value={testcacheObject.addressline1}
                                    name="addressline1"
                                />
                                <Form.Field
                                    onChange={this.handleInputChange}
                                    control={Input}
                                    type="text"
                                    label="Address Line 2"
                                    placeholder="Address Line 2"
                                    value={testcacheObject.addressline2}
                                    name="addressline2"
                                />
                                <Form.Field
                                    onChange={this.handleInputChange}
                                    control={Input}
                                    type="text"
                                    label="Address Line 3"
                                    placeholder="Address Line 3"
                                    value={testcacheObject.addressline3}
                                    name="addressline3"
                                />
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <h4 className="page-section-header">
                                    Locality+ :
                                </h4>

                                <Form.Group widths="equal">
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="House Number"
                                        placeholder="House Number"
                                        value={testcacheObject.housenumber}
                                        name="housenumber"
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Thoroughfare"
                                        placeholder="Thoroughfare"
                                        value={testcacheObject.thoroughfare}
                                        name="thoroughfare"
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Locality"
                                        placeholder="Locality"
                                        value={testcacheObject.locality}
                                        name="locality"
                                    />
                                </Form.Group>

                                <Form.Group widths="equal">
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Administrative Area"
                                        placeholder="Administrative Area"
                                        value={testcacheObject.administrativearea}
                                        name="administrativearea"
                                    />
                                    <Form.Field
                                        onChange={this.handleInputChange}
                                        control={Input}
                                        type="text"
                                        label="Postal Code"
                                        placeholder="Postal Code"
                                        value={testcacheObject.postalcode}
                                        name="postalcode"
                                    />
                                    <Form.Field required>
                                        <label>Country</label>
                                        <Select
                                            onChange={this.handleTestcacheCountryChange}
                                            options={countryOptions}
                                            placeholder="Country"
                                            isSearchable={true}
                                            isClearable={true}
                                            name="countrycode"
                                            value={lodash.find(countryOptions, {
                                                value: testcacheObject.countrycode
                                            })}
                                        />
                                    </Form.Field>
                                </Form.Group>
                            </Card.Content>
                        </Card>

                        <Card fluid>
                            <Card.Content>
                                <JsonViewer value={postmanObject} />
                            </Card.Content>
                        </Card>

                        <div ref={this.messagesEndRef}/>
                    </Form>

                    {formWarningNotification || formErrorNotification
                        ? (
                            <div style={{paddingTop: "30px"}}>
                                <Message
                                    error={formErrorNotification}
                                    warning={formWarningNotification}
                                    header={formMessageHeader}
                                    list={formMessage}
                                    visible={formWarningNotification || formErrorNotification}
                                    onDismiss={this.handleTestcacheDismiss}
                                />
                            </div>
                        )
                        : null}

                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    formMessage: state.marvel.message.formMessage,
    formWarningNotification: state.marvel.message.formWarningNotification,
    formErrorNotification: state.marvel.message.formErrorNotification,
    formMessageHeader: state.marvel.message.formMessageHeader,

    testcacheObject: state.support.addEditTestcache.testcacheObject,
    postmanObject: state.support.addEditTestcache.postmanObject,
    sourceTypeOptions: state.support.testcache.sourceTypeOptions,
});

const mapDispatchToProps = dispatch => ({
    setTestcacheForm: ({ name, value }) => {dispatch(setTestcacheFormValues({name, value}))},
    setDateOfBirth: ({ day }) => {dispatch(setDateOfBirthTestcache({day}))},
    setTestcacheRecordCountry: ({ country }) => {dispatch(setTestcacheCountry({country}))},
    setTestcacheSourceType: ({ data_source_type }) =>
    {dispatch(setTestcacheSourceType({data_source_type}))},
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AddEditTestcacheForm)
